import { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from './button/PrimaryButton.jsx';
import PromoCard from './card/PromoCard.jsx';
import { ACCOUNT, HOME } from '../constants/routes';
import { useSelector } from 'react-redux';
import confetti from 'canvas-confetti';
import FidelityCard from './card/FidelityCard.jsx';
import InvoiceCard from './card/InvoiceCard.jsx';
import RatingCard from './card/RatingCard.jsx';
import { CreateAccountCard } from './CreateAccountCard.jsx';
import InstallPWA from './InstallPwa.jsx';
import EndScreenFidelity from '../pages/account/fid/EndScreenFidelity.jsx';
import { isAppPWA } from '../utils/helper-functions.js';
import { ProductRating } from './card/ProductRating.jsx';
import { useTheme } from 'styled-components';
import { LottieLogo } from '../utils/LottieLogo.jsx';
import GenerateBarcode from '../utils/GenerateBarcode';
import BetaUserBottomSheet from './betaUserForm/BetaUserBottomSheet';
import { MdHomeFilled } from 'react-icons/md';
import { shouldShowWaitlistBottomSheet, setIsUserInWaitlistInLocalStorage } from '../utils/waitlist/useWaitlist';
import { prodBetaUserStore } from '../utils/waitlist/useWaitlist';
function PikkoPayButton({ handleClick }) {
  return (
    <button
      type="button"
      className="flex items-center gap-2 bg-white text-black rounded-full px-6 py-2 shadow hover:shadow-md transition border border-gray-200 mb-8 cursor-pointer"
      onClick={() => handleClick()}>
      <div className="flex justify-center items-center ">
        <MdHomeFilled size={28} className="bg-gray-200 rounded-full p-1" />
      </div>
      <span className="font-bold text-3xl">PikkoPay</span>
    </button>
  );
}

function SuccessAnimationHeader({ animation, theme }) {
  return (
    <div
      className={
        animation
          ? 'flex flex-col min-h-[100vh] max-w-[200px] duration-2000 w-full mb-10 pt-[20%] items-center justify-start gap-4'
          : 'flex pt-[0%] pl-6 w-full max-w-[600px] flex-col min-h-[100px] duration-2000 items-center justify-start gap-4 mb-10'
      }
    >
      <h2
        className={
          animation
            ? 'text-6xl geomanistBold duration-2000 max-h-[100px]'
            : 'text-6xl duration-2000 geomanistBold opacity-0 max-h-0 overflow-hidden'
        }
      >
        Bravo !
      </h2>
      <div className="flex w-full items-center justify-start">
        <Lottie
          loop={LottieLogo[theme?.name]?.loop}
          animationData={LottieLogo[theme?.name]?.image}
          className={
            animation
              ? 'opacityAnimation w-[200px] h-[200px] duration-2000'
              : 'w-[80px] h-[80px] duration-2000'
          }
        />
        <div
          className={`duration-2000 h-full flex flex-col justify-center overflow-hidden ${animation ? 'max-w-0 opacity-0' : 'max-w-[300px] opacity-1'}`}
        >
          <h2 className="text-4xl geomanistBold mb-2 overflow-hidden flex flex-nowrap gap-2">
            Félicitations <span>!</span>
          </h2>
          <p className="text-xl overflow-hidden flex flex-nowrap gap-2 w-[190px]">
            Tu as finalisé ton Pikko Achat !
          </p>
        </div>
      </div>
    </div>
  );
}

confetti.Promise = window.Promise;

function lancerConfettis(theme) {
  return new Promise((resolve, _reject) => {
    const scalar = 5;
    const heart = confetti.shapeFromText({
      text: theme.confettis,
      scalar,
      fontFamily: 'Apple Color Emoji'
    });

    const defaults = {
      spread: 300,
      origin: { y: 0, x: 0.6 },
      shapes: [heart],
      scalar,
    };
    confetti({ ...defaults });

    setTimeout(resolve, 2000);
  });
}

const SuccessAnimation = ({ cartItems, earnPoints }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const [openBetaUserBottomSheet, setOpenBetaUserBottomSheet] = useState(false);
  const [isAvailableStoreToJoinWaitlist, setIsAvailableStoreToJoinWaitlist] = useState(false);
  const isToolkitEnabled =
  process.env.REACT_APP_TOOLKIT?.toUpperCase() === 'TRUE';
  const isDevOrStageEnv = process.env.NODE_ENV === 'development' || isToolkitEnabled;
  let isOpenAndAvailableStoreToJoinWaitlist = openBetaUserBottomSheet && isAvailableStoreToJoinWaitlist;
  let isVisibleBetaUserBottomSheet = isOpenAndAvailableStoreToJoinWaitlist || isDevOrStageEnv;
  useEffect(() => {
    if (store?.id) {
      setIsAvailableStoreToJoinWaitlist(Object.values(prodBetaUserStore).includes(store?.id));
    }
  }, [store]);
  const [animation, setAnimation] = useState(true);

  const isPWA = isAppPWA();

  const handleClick = () => {
    lancerConfettis(theme)
      .then(() => {
        console.info('Confettis terminés !');
      })
      .catch((error) => {
        console.error('Erreur lors de la diffusion des confettis :', error);
      });
  };

  useEffect(() => {
    handleClick();

    setTimeout(() => {
      setAnimation(false);
    }, 2000);
  }, []);

  useEffect(() => {
    const checkWaitlist = async () => {
      try {
        const shouldShow = await shouldShowWaitlistBottomSheet(user);
        setOpenBetaUserBottomSheet(shouldShow);
      } catch (error) {
        console.error('Erreur lors de la vérification de la waitlist:', error);
      }
    };

    checkWaitlist();
  }, [user]);

  const checkAllPromoUsed = () => {
    const welcomePromo = user?.currentPromo?.filter(
      (item) => item.type === 'welcome',
    );
    return !(welcomePromo && welcomePromo.length > 0);
  };

  const goHome = () => {
    navigate(user?._id ?
      (isPWA ? HOME : ACCOUNT)
      : HOME
    );
  };


  const handleDismissBetaUserBottomSheet = () => {
    setOpenBetaUserBottomSheet(false);
  };

  const handleTicketHide = () => {
    setOpenBetaUserBottomSheet(false);
    setIsUserInWaitlistInLocalStorage();
  };

  return (
    <div className="justify-start z-50 pt-14 flex flex-col items-center bg-gradient2 overflow-y-auto overflow-x-hidden pb-[100px]">
      <PikkoPayButton handleClick={goHome} />
      <SuccessAnimationHeader animation={animation} theme={theme} />

      <div
        className={`
          duration-2000 h-full w-full flex flex-col items-center gap-[1.5em]
          ${animation ? 'max-h-[0]' : 'max-h-[1500px]'}
        `}
      >

        {cartItems?.checkoutBarcode && (
          <GenerateBarcode
            value={cartItems?.checkoutBarcode}
          />
        )}
        <RatingCard store={store} />

        <h2
          className="text-start ml-14 text-3xl w-full"
          style={{ fontFamily: 'intersemibold' }}
        >
        </h2>

        {theme?.screenDecorations?.successScreenDecoration?.image && (
          <img
            src={theme?.screenDecorations?.successScreenDecoration?.image}
            alt="pikkocoin"
            className="w-[50px] h-[50px]  absolute right-0 top-10 z-0"
          />
        )}

        <InvoiceCard cartItems={cartItems} />

        <ProductRating cartItems={cartItems} user={user} />

        {!user?._id && <CreateAccountCard />}

        {!isAppPWA() && (
          <div className="pwa-btn-container">
            <InstallPWA isAnim={true} />
          </div>
        )}

        <div className="bottom_btn_by_margin px-8 pt-4">
          <PrimaryButton
            label="Retourner à l’accueil"
            onClick={() => goHome()}
          />
        </div>
      </div>
    </div>
  );
};

export default SuccessAnimation;
